module.exports = __webpack_public_path__ + "img/enrolled-student-2.36d6ef7c.png";